/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Peryear1Inputs */

const zh_plan_peryear1 = /** @type {(inputs: Plan_Peryear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/年`)
};

const en_plan_peryear1 = /** @type {(inputs: Plan_Peryear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/yr`)
};

const es_plan_peryear1 = /** @type {(inputs: Plan_Peryear1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/año`)
};

/**
* | output |
* | --- |
* | "/yr" |
*
* @param {Plan_Peryear1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const plan_peryear1 = /** @type {((inputs?: Plan_Peryear1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Peryear1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_plan_peryear1(inputs)
	if (locale === "en") return en_plan_peryear1(inputs)
	return es_plan_peryear1(inputs)
});
export { plan_peryear1 as "plan_perYear" }